import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewingToursFormComponent } from './viewing-tours-form.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TimePickerModule } from 'app/components/time-picker/time-picker.module';
import { QuickAddModule } from 'app/main/master-data/accounts/quick-add/quick-add.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRippleModule } from '@angular/material/core';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LoadersModule } from 'app/main/shared/modules/loaders/loaders.module';
// import { SignaturePadModule } from 'ngx-signaturepad';
import { NgxSignaturePadModule } from '@eve-sama/ngx-signature-pad';
import { QuickAddOwnersModule } from 'app/main/master-data/owners/quick-add-owners/quick-add-owners.module';
import { TooltipModule } from 'ng2-tooltip-directive-ngfix';

@NgModule({
    declarations: [
        ViewingToursFormComponent
    ],
    imports: [
        CommonModule,
        FuseSharedModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatOptionModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatMenuModule,
        MatToolbarModule,
        MatChipsModule,
        MatExpansionModule,
        MatRippleModule,
        MatSnackBarModule,
        NgxMatSelectSearchModule,
        TimePickerModule,
        QuickAddModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatTooltipModule,
        LoadersModule,
        NgxSignaturePadModule,
        // SignaturePadModule,
        QuickAddOwnersModule,
        TooltipModule
    ],
    exports: [
        ViewingToursFormComponent
    ]
})
export class ViewingToursFormModule { }
